import { amplifyClient } from 'api';
import { getUrlToFetchAndAdd, getUrlToUpdateAndRemove } from 'features/areas/endpoints';
import { createApiSlice } from 'helpers/createApiSlice';
import { parsePaginatedResponse } from 'helpers/pagination';
import { call } from 'redux-saga/effects';
import {
  AnyRecord,
  ApiStateData,
  DataWithPagination,
  MakerSelectors,
  Pagination,
  UserArea,
} from 'types';

/**
 * FETCH
 */
type DataFetch = DataWithPagination<UserArea>;

type PayloadFetch = {
  companyId?: string;
};

interface ExtraSelectors extends MakerSelectors<ApiStateData<DataFetch>> {
  getData: (d: ApiStateData<DataFetch>) => Array<UserArea> | null;
  getPagination: (d: ApiStateData<DataFetch>) => Pagination | undefined;
}

export const areasFetch = createApiSlice<DataFetch, PayloadFetch | undefined, ExtraSelectors>({
  name: 'areasFetch',
  *tryGenerator(_, { payload }) {
    const { companyId } = payload || {};

    const { data } = yield call(amplifyClient, {
      method: 'get',
      url: getUrlToFetchAndAdd(companyId),
    });

    return {
      pageObjects: data, // TODO fix the pagination in the back
    };
  },
  extraSelectors: {
    getData: (data) => parsePaginatedResponse(data).data,
    getPagination: (data) => parsePaginatedResponse(data).pagination,
  },
});

/**
 * ADD
 */
type PayloadAdd = {
  data: Record<string, unknown>;
  companyId?: string;
};

export const areasAdd = createApiSlice<unknown, PayloadAdd>({
  name: 'areasAdd',
  *tryGenerator(_, { payload: { data, companyId } }) {
    yield call(amplifyClient, {
      method: 'post',
      url: getUrlToFetchAndAdd(companyId),
      data,
    });

    return null;
  },
});

/**
 * UPDATE
 */

type PayloadUpdate = {
  data: AnyRecord;
  companyId?: string;
};

export const areasUpdate = createApiSlice<unknown, PayloadUpdate>({
  name: 'areasUpdate',
  *tryGenerator(_, { payload: { data, companyId } }) {
    const { id: areaId, ...remainderData } = data;

    yield call(amplifyClient, {
      method: 'put',
      url: getUrlToUpdateAndRemove(areaId, companyId),
      data: remainderData,
    });

    return null;
  },
});

/**
 * REMOVE
 */

type PayloadRemove = {
  id: string;
  companyId?: string;
};

export const areasRemove = createApiSlice<unknown, PayloadRemove>({
  name: 'areasRemove',
  *tryGenerator(_, { payload: { id, companyId } }) {
    yield call(amplifyClient, {
      method: 'del',
      url: getUrlToUpdateAndRemove(id, companyId),
    });

    return null;
  },
});
